/** Queries for 'Delatnost' */

import { tag } from 'api/rtkTags'
// eslint-disable-next-line
import { initialBusinessActivity } from 'constants/initialValues'
import { label } from 'constants/labels'

export const queryGetPagedBusinessActivity = (pageNumber, pageSize, options = {}) => {
  return {
    query: {
      name: 'data',
      mode: 'page',
      type: 'delatnost',
      data: {
        pageNumber,
        pageSize,
        options
      }
    },
    providesTags: {
      type: tag.businessActivity
    }
  }
}

export const queryGetAllBusinessActivity = () => {
  return {
    query: {
      name: 'data',
      mode: 'all',
      type: 'delatnost',
      data: {}
    },
    providesTags: {
      type: tag.businessActivity
    }
  }
}
/**
 * @param {initialBusinessActivity} data
 */

export const queryAddBusinessActivity = data => {
  return {
    query: {
      name: 'data',
      mode: 'new',
      type: 'delatnost',
      data: { values: data }
    },
    invalidatesTags: [tag.businessActivity],
    successMsg: label.successMsgCreate + ' ' + label.msgActivity
  }
}

/**
* @param {initialBusinessActivity} data
@param {string} id
*/
export const queryUpdateBusinessActivity = (data, id) => {
  return {
    query: {
      name: 'data',
      mode: 'update',
      type: 'delatnost',
      data: {
        values: data,
        options: {
          where: {
            id
          }
        }
      }
    },
    invalidatesTags: [tag.businessActivity],
    successMsg: label.successMsgEdit + ' ' + label.msgActivity
  }
}

/**
  * @param {initialBusinessActivity} data
  @param {string} id
  */

/**
@param {string} id
*/
export const queryDeleteBusinessActivity = id => {
  return {
    query: {
      name: 'data',
      mode: 'delete',
      type: 'delatnost',
      data: {
        options: {
          where: { id }
        }
      }
    },
    invalidatesTags: [tag.businessActivity],
    successMsg: label.successMsgDelete + ' ' + label.msgActivity
  }
}
